import React from 'react'
import Popover from 'material-ui/Popover'
import Chip from 'material-ui/Chip'
import { DropDownEmail, DropDownUserName } from './styles'
import config from '../../../config/config'
import { displayRole } from '../../../lib/lib'

const ProfileDropDown = ({
   direct,
   logoutSuccess,
   open,
   anchorEl,
   anchorOrigin,
   targetOrigin,
   onRequestClose,
   email,
   accountType,
   name,
   logoutUser,
   recieveLoginstatus,
   shouldRedirectUser,
   user_id,
   role,
   location
 }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      targetOrigin={targetOrigin}
      onRequestClose={onRequestClose}
      zDepth={4}
      className='popover'
      style={{overflowY: 'none', border: 3}}
    >
      <div className='pa3 flex'>
        <div>
          <img
            src={`https://${config.API_HOST}/api/v1/image/${(direct) ? name : user_id}`}
            alt='profile'/>
        </div>
        <div className='pl3 flex justify-around flex-column'>
          <DropDownUserName>
            {name}
          </DropDownUserName>
          <DropDownEmail>
            {email}
          </DropDownEmail>
          <div>
            <Chip backgroundColor='#4688F1'>
              <div className='white ttu'>
                {displayRole(location, role)}
              </div>
            </Chip>
          </div>
        </div>
      </div>
    </Popover>
  )
}

export default ProfileDropDown



// WEBPACK FOOTER //
// ./src/components/Profile/NavBarProfile/ProfileDropDown.js